<template>
  <v-navigation-drawer app fixed clipped permanent right :width="width">

    <v-list class="py-0">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold total-text text-uppercase text-center">Total da Venda</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text--secondary font-weight-bold text-body-1">Itens</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-list-item-title class="font-weight-normal total-text text-right">{{ pdvStore.pedido.itens | valorBR(0) }}</v-list-item-title>
        </v-list-item-action>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text--secondary font-weight-bold text-body-1">Quantidade</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-list-item-title class="font-weight-normal total-text text-right">{{ pdvStore.pedido.quantidade_total | valorQTD(configStore.configuracoes.CASAS_DECIMAIS_QUANTIDADE) }}</v-list-item-title>
        </v-list-item-action>
      </v-list-item>

      <v-divider></v-divider>
      
      <v-list-item value="Blusas">
        <v-list-item-content>
          <v-list-item-title class="text--secondary font-weight-bold text-body-1">Total</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-list-item-title class="font-weight-bold total-text text-right">R$ {{ pdvStore.pedido.valor_bruto | valorBR(2) }}</v-list-item-title>
        </v-list-item-action>
      </v-list-item>
      
      <v-divider></v-divider>

    </v-list>
    
    <v-container>
      <v-btn 
        color="primary" 
        block 
        depressed 
        rounded
        :disabled="pdvStore.pedido.produtos.length == 0"
        @click="$emit('finalizarVenda')"
      >F5 - Finalizar Venda</v-btn>
    </v-container>

    <template #append>
      <v-divider></v-divider>
      
      <div class="pa-1 text-center">
        <span>{{ config.APP_VERSION }}</span>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script setup>
import { ref } from 'vue';
import { usePDVStore } from '@/app/store/pinia/pdv';
import { useConfigStore } from '@/app/store/pinia/configuracoes';

import config from "@/app/config";

const pdvStore = usePDVStore();
const configStore = useConfigStore();

const props = defineProps({
  width: {
    type: [Number, String],
    default: 250
  }
});

</script>

<style scoped>
  .total-text {
    font-size: 1.5rem;
  }
</style>